import { components } from 'lib/api/firebase/apis/api-config/api-paths-v2.ts.types';

/**
 * Province enum for Canadian provinces and territories.
 */
export enum Province {
  ONTARIO = 'ontario',
  QUEBEC = 'quebec',
  NOVA_SCOTIA = 'nova-scotia',
  NEW_BRUNSWICK = 'new-brunswick',
  MANITOBA = 'manitoba',
  BRITISH_COLUMBIA = 'british-columbia',
  PRINCE_EDWARD_ISLAND = 'prince-edward-island',
  SASKATCHEWAN = 'saskatchewan',
  ALBERTA = 'alberta',
  NEWFOUNDLAND_AND_LABRADOR = 'newfoundland-and-labrador',
  NORTHWEST_TERRITORIES = 'northwest-territories',
  YUKON = 'yukon',
  NUNAVUT = 'nunavut'
}

/**
 * USState enum for United States states.
 */
export enum USState {
  ALABAMA = 'alabama',
  ALASKA = 'alaska',
  ARIZONA = 'arizona',
  ARKANSAS = 'arkansas',
  CALIFORNIA = 'california',
  COLORADO = 'colorado',
  CONNECTICUT = 'connecticut',
  DELAWARE = 'delaware',
  FLORIDA = 'florida',
  GEORGIA = 'georgia',
  HAWAII = 'hawaii',
  IDAHO = 'idaho',
  ILLINOIS = 'illinois',
  INDIANA = 'indiana',
  IOWA = 'iowa',
  KANSAS = 'kansas',
  KENTUCKY = 'kentucky',
  LOUISIANA = 'louisiana',
  MAINE = 'maine',
  MARYLAND = 'maryland',
  MASSACHUSETTS = 'massachusetts',
  MICHIGAN = 'michigan',
  MINNESOTA = 'minnesota',
  MISSISSIPPI = 'mississippi',
  MISSOURI = 'missouri',
  MONTANA = 'montana',
  NEBRASKA = 'nebraska',
  NEVADA = 'nevada',
  NEW_HAMPSHIRE = 'new-hampshire',
  NEW_JERSEY = 'new-jersey',
  NEW_MEXICO = 'new-mexico',
  NEW_YORK = 'new-york',
  NORTH_CAROLINA = 'north-carolina',
  NORTH_DAKOTA = 'north-dakota',
  OHIO = 'ohio',
  OKLAHOMA = 'oklahoma',
  OREGON = 'oregon',
  PENNSYLVANIA = 'pennsylvania',
  RHODE_ISLAND = 'rhode-island',
  SOUTH_CAROLINA = 'south-carolina',
  SOUTH_DAKOTA = 'south-dakota',
  TENNESSEE = 'tennessee',
  TEXAS = 'texas',
  UTAH = 'utah',
  VERMONT = 'vermont',
  VIRGINIA = 'virginia',
  WASHINGTON = 'washington',
  WEST_VIRGINIA = 'west-virginia',
  WISCONSIN = 'wisconsin',
  WYOMING = 'wyoming'
}

const createOption = <Key extends string, Value extends string>(
  label: Key,
  value: Value,
  labelSuffix?: string
) => ({
  label: labelSuffix ? `${label} (${labelSuffix})` : label,
  value: value
});

export const OPTIONS_PROVINCES = [
  createOption('Ontario', Province.ONTARIO, "CANADA"),
  createOption('Quebec', Province.QUEBEC, "CANADA"),
  createOption('Nova Scotia', Province.NOVA_SCOTIA, "CANADA"),
  createOption('New Brunswick', Province.NEW_BRUNSWICK, "CANADA"),
  createOption('Manitoba', Province.MANITOBA, "CANADA"),
  createOption('British Columbia', Province.BRITISH_COLUMBIA, "CANADA"),
  createOption('Prince Edward Island', Province.PRINCE_EDWARD_ISLAND, "CANADA"),
  createOption('Saskatchewan', Province.SASKATCHEWAN, "CANADA"),
  createOption('Alberta', Province.ALBERTA, "CANADA"),
  createOption('Newfoundland and Labrador', Province.NEWFOUNDLAND_AND_LABRADOR, "CANADA"),
  createOption('Northwest Territories', Province.NORTHWEST_TERRITORIES, "CANADA"),
  createOption('Yukon', Province.YUKON, "CANADA"),
  createOption('Nunavut', Province.NUNAVUT, "CANADA")
];
const US_LABEL = "UNITED STATES"
export const OPTIONS_STATES = [
  createOption('Alabama', USState.ALABAMA, US_LABEL),
  createOption('Alaska', USState.ALASKA, US_LABEL),
  createOption('Arizona', USState.ARIZONA, US_LABEL),
  createOption('Arkansas', USState.ARKANSAS, US_LABEL),
  createOption('California', USState.CALIFORNIA, US_LABEL),
  createOption('Colorado', USState.COLORADO, US_LABEL),
  createOption('Connecticut', USState.CONNECTICUT, US_LABEL),
  createOption('Delaware', USState.DELAWARE, US_LABEL),
  createOption('Florida', USState.FLORIDA, US_LABEL),
  createOption('Georgia', USState.GEORGIA, US_LABEL),
  createOption('Hawaii', USState.HAWAII, US_LABEL),
  createOption('Idaho', USState.IDAHO, US_LABEL),
  createOption('Illinois', USState.ILLINOIS, US_LABEL),
  createOption('Indiana', USState.INDIANA, US_LABEL),
  createOption('Iowa', USState.IOWA, US_LABEL),
  createOption('Kansas', USState.KANSAS, US_LABEL),
  createOption('Kentucky', USState.KENTUCKY, US_LABEL),
  createOption('Louisiana', USState.LOUISIANA, US_LABEL),
  createOption('Maine', USState.MAINE, US_LABEL),
  createOption('Maryland', USState.MARYLAND, US_LABEL),
  createOption('Massachusetts', USState.MASSACHUSETTS, US_LABEL),
  createOption('Michigan', USState.MICHIGAN, US_LABEL),
  createOption('Minnesota', USState.MINNESOTA, US_LABEL),
  createOption('Mississippi', USState.MISSISSIPPI, US_LABEL),
  createOption('Missouri', USState.MISSOURI, US_LABEL),
  createOption('Montana', USState.MONTANA, US_LABEL),
  createOption('Nebraska', USState.NEBRASKA, US_LABEL),
  createOption('Nevada', USState.NEVADA, US_LABEL),
  createOption('New Hampshire', USState.NEW_HAMPSHIRE, US_LABEL),
  createOption('New Jersey', USState.NEW_JERSEY, US_LABEL),
  createOption('New Mexico', USState.NEW_MEXICO, US_LABEL),
  createOption('New York', USState.NEW_YORK, US_LABEL),
  createOption('North Carolina', USState.NORTH_CAROLINA, US_LABEL),
  createOption('North Dakota', USState.NORTH_DAKOTA, US_LABEL),
  createOption('Ohio', USState.OHIO, US_LABEL),
  createOption('Oklahoma', USState.OKLAHOMA, US_LABEL),
  createOption('Oregon', USState.OREGON, US_LABEL),
  createOption('Pennsylvania', USState.PENNSYLVANIA, US_LABEL),
  createOption('Rhode Island', USState.RHODE_ISLAND, US_LABEL),
  createOption('South Carolina', USState.SOUTH_CAROLINA, US_LABEL),
  createOption('South Dakota', USState.SOUTH_DAKOTA, US_LABEL),
  createOption('Tennessee', USState.TENNESSEE, US_LABEL),
  createOption('Texas', USState.TEXAS, US_LABEL),
  createOption('Utah', USState.UTAH, US_LABEL),
  createOption('Vermont', USState.VERMONT, US_LABEL),
  createOption('Virginia', USState.VIRGINIA, US_LABEL),
  createOption('Washington', USState.WASHINGTON, US_LABEL),
  createOption('West Virginia', USState.WEST_VIRGINIA, US_LABEL),
  createOption('Wisconsin', USState.WISCONSIN, US_LABEL),
  createOption('Wyoming', USState.WYOMING, US_LABEL)
];


export const OPTIONS_PROVINCES_OR_STATES = [...OPTIONS_PROVINCES, ...OPTIONS_STATES];

type A = components['schemas']['Clinic'];
export interface Clinic extends A {}
